import type { ProjectId } from "../api/types";

/**
 * The onboarding project whose GitHub App install is in flight (FLOW-991).
 *
 * `GitHubWizard.handleInstallApp` leaves the SPA with a full-page navigation
 * to `/api/github/app/install`, which destroys every signal in the wizard —
 * `WelcomeWizard`'s `createdProject` included. The project itself already
 * exists server-side; only the handle to it is lost, so a marker in
 * `localStorage` (the same place the wizard already stashes
 * `github_app_return_url`) is enough to pick the flow back up on return.
 *
 * Written when leaving for GitHub, read once by `AppShell` on the way back,
 * and consumed by the wizard it resumes — one write, one read, one clear.
 */
export const ONBOARDING_PROJECT_KEY = "flowicity_onboarding_project";

export function markOnboardingInFlight(projectId: ProjectId): void {
  try {
    localStorage.setItem(ONBOARDING_PROJECT_KEY, projectId);
  } catch {
    // Storage can be unavailable (private mode, quota). Losing the marker
    // only costs the resume, which AppShell already treats as optional.
  }
}

export function readOnboardingInFlight(): string | null {
  try {
    return localStorage.getItem(ONBOARDING_PROJECT_KEY);
  } catch {
    return null;
  }
}

export function clearOnboardingInFlight(): void {
  try {
    localStorage.removeItem(ONBOARDING_PROJECT_KEY);
  } catch {
    // Nothing to do — see markOnboardingInFlight.
  }
}
